const FromArr = [{
	title: "L1：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 52,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "L2：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 38,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "L3：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "L4：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 36,
	marginTop: 28,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "类型名称：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 22,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	title: "经销商：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请输入",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	title: "医院：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请输入",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 24,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500
}]
export default FromArr;